import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import useInputValue from '../hooks/useInputValue';
import useCheckValue from '../hooks/useCheckValue';
import useRadioButtonValue from '../hooks/useRadioButtonValue';
import '../assets/styles/components/FormBookNow.sass';

const FormBookNow = ( props ) => {
  const [modal, setModal] = useState('none');
  const [pricing, setPricing] = useState([]);
  const name = useInputValue('');
  const surname = useInputValue('');
  const email = useInputValue('');
  const phone = useInputValue('');
  const type_id = useInputValue('');
  const number = useInputValue('');
  const blood_group = useInputValue('');
  const eps = useInputValue('');
  const nacionality = useInputValue('');
  const sex = useInputValue('');
  const birthday_day = useInputValue('');
  const birthday_month = useInputValue('');
  const birthday_year = useInputValue('');
  const address = useInputValue('');
  const city = useInputValue('');
  const country = useInputValue('');
  const emergency_contact_name = useInputValue('');
  const emergency_contact_number = useInputValue('');
  const jersey_size = useInputValue('');
  const t_shirt_size = useInputValue('');
  const instagram = useInputValue('');
  const know = useInputValue('');
  const type_of_bike = useInputValue('');
  const make_of_bike = useInputValue('');
  const chainset = useInputValue('');
  const wheel_size = useInputValue('');
  const number_of_speeds = useInputValue('');
  const make_of_brakes = useInputValue('');
  const drivetrain = useInputValue('');
  const payment = useInputValue('');
  const medical_conditions = useInputValue('');
  const liability_disclaimer = useCheckValue(false);
  const terms_and_conditions = useCheckValue(false);
  const medical = useCheckValue(false);
  const signature = useInputValue('');
  const dateTour = useRadioButtonValue('');
  const [errors, setErrors] = useState();

  useEffect(() => {
    const session = sessionStorage.getItem('la-leyenda-adventures');
    const data = JSON.parse(session);
    if (data?.signature) {
      name.setValue(data.name);
      surname.setValue(data.surname);
      phone.setValue(data.phone);
      email.setValue(data.email);
      type_id.setValue(data.type_id);
      number.setValue(data.number);
      blood_group.setValue(data.blood_group);
      eps.setValue(data.eps);
      nacionality.setValue(data.nacionality);
      sex.setValue(data.sex);
      birthday_day.setValue(data.birthday_day);
      birthday_month.setValue(data.birthday_month);
      birthday_year.setValue(data.birthday_year);
      address.setValue(data.address);
      city.setValue(data.city);
      country.setValue(data.country);
      emergency_contact_name.setValue(data.emergency_contact_name);
      emergency_contact_number.setValue(data.emergency_contact_number);
      jersey_size.setValue(data.jersey_size);
      t_shirt_size.setValue(data.t_shirt_size);
      instagram.setValue(data.instagram);
      know.setValue(data.know);
      type_of_bike.setValue(data.type_of_bike)
      make_of_bike.setValue(data.make_of_bike)
      chainset.setValue(data.chainset)
      wheel_size.setValue(data.wheel_size)
      number_of_speeds.setValue(data.number_of_speeds)
      make_of_brakes.setValue(data.make_of_brakes)
      drivetrain.setValue(data.drivetrain)
      payment.setValue(data.payment)
      medical_conditions.setValue(data.medical_conditions);
      liability_disclaimer.setChecked(data.liability_disclaimer);
      terms_and_conditions.setChecked(data.terms_and_conditions);
      medical.setChecked(data.medical);
      signature.setValue(data.signature);
      dateTour.setData(data.date);
    }
  }, []);
  
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/booknow_pricing/${props.package}`)
    .then(data => data.json())
    .then(data => {
      setPricing(data.booknows)
      sessionStorage.setItem("lldd-adventures-pricing", JSON.stringify(data.booknows));
    })
    .catch(err => setErrors(err.errors))
  }, [props.package])

  const handleOpenModal = () => {
    setModal('block');
  }

  const handleCloseModal = () => {
    setModal('none');
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("name", name.value);
    formData.append("surname", surname.value);
    formData.append("phone", phone.value);
    formData.append("email", email.value);
    formData.append("type_id", type_id.value);
    formData.append("number", number.value);
    formData.append("blood_group", blood_group.value);
    formData.append("eps", eps.value);
    formData.append("nacionality", nacionality.value);
    formData.append("sex", sex.value);
    formData.append("birthday_day", birthday_day.value);
    formData.append("birthday_month", birthday_month.value);
    formData.append("birthday_year", birthday_year.value);
    formData.append("address", address.value);
    formData.append("city", city.value);
    formData.append("country", country.value);
    formData.append("emergency_contact_name", emergency_contact_name.value);
    formData.append("emergency_contact_number", emergency_contact_number.value);
    formData.append("jersey_size", jersey_size.value);
    formData.append("t_shirt_size", t_shirt_size.value);
    formData.append("instagram", instagram.value);
    formData.append("know", know.value);
    formData.append("type_of_bike", type_of_bike.value);
    formData.append("make_of_bike", make_of_bike.value);
    formData.append("chainset", chainset.value);
    formData.append("wheel_size", wheel_size.value);
    formData.append("number_of_speeds", number_of_speeds.value);
    formData.append("make_of_brakes", make_of_brakes.value);
    formData.append("drivetrain", drivetrain.value);
    formData.append("payment", payment.value);
    formData.append("medical_conditions", medical_conditions.value);
    formData.append("liability_disclaimer", liability_disclaimer.checked);
    formData.append("terms_and_conditions", terms_and_conditions.checked);
    formData.append("medical", medical.checked);
    formData.append("signature", signature.value);
    formData.append("date", dateTour.data);
    formData.append("tour", props.package);
    formData.append("language", 'es');

    fetch(`${process.env.REACT_APP_URL}/api/adventures/register`, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
      headers:{
        'Content-Type': 'application/json'
      }
    })
    .then(data => data.json())
    .then(data => {
      if (data.errors) {
        return setErrors(data.errors);
      }
      return redirectSession();
    })
    .catch(err => setErrors(err.errors))
  }

  const redirectSession = () => {
    const save = {
      'name': name.value,
      'surname': surname.value,
      'phone': phone.value,
      'email': email.value,
      'type_id': type_id.value,
      'number': number.value,
      'blood_group': blood_group.value,
      'eps': eps.value,
      'nacionality': nacionality.value,
      'sex': sex.value,
      'birthday_day': birthday_day.value,
      'birthday_month': birthday_month.value,
      'birthday_year': birthday_year.value,
      'address': address.value,
      'city': city.value,
      'country': country.value,
      'emergency_contact_name': emergency_contact_name.value,
      'emergency_contact_number': emergency_contact_number.value,
      'jersey_size': jersey_size.value,
      't_shirt_size': t_shirt_size.value,
      'instagram': instagram.value,
      'know': know.value,
      'type_of_bike': type_of_bike.value,
      'make_of_bike': make_of_bike.value,
      'chainset': chainset.value,
      'wheel_size': wheel_size.value,
      'number_of_speeds': number_of_speeds.value,
      'make_of_brakes': make_of_brakes.value,
      'drivetrain': drivetrain.value,
      'payment': payment.value,
      'medical_conditions': medical_conditions.value,
      'liability_disclaimer': liability_disclaimer.checked,
      'terms_and_conditions': terms_and_conditions.checked,
      'medical': medical.checked,
      'signature': signature.value,
      'date': dateTour.data,
      'tour': props.package,
    };
    
    sessionStorage.setItem("la-leyenda-adventures", JSON.stringify(save));
    window.location.href = "/adventures/check-info";
  }

  return (
    <div className="row FormBookNow">
      <div className="container">

        {/* Form */}
        <div className="row my-4">
          <div className="col-12">
            <form onSubmit={event => handleSubmit(event)}>

              <div className="form-group row">
                <label htmlFor="name" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Seleccione fecha del tour</label>
                <div className="col-md-6 form-check">

                  {pricing.map((item, index) => (
                    <div key={index} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="date"
                        id={item.value}
                        value={item.value}
                        checked={dateTour.data === item.value}
                        {...dateTour}
                        />
                      <label className="form-check-label" htmlFor={item.value}>
                        {ReactHtmlParser(item.content_es)}
                      </label>
                    </div>
                  ))}

                  <span className="help-block red">{errors?.date ? 'Requerido' : ''}</span>

                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="name" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Nombres</label>
                <div className="col-md-6">
                  <input id="name" type="text" className={`form-control ${errors?.name ? 'is-invalid' : ''}`} name="name" {...name} />
                  <span className="help-block red">{errors?.name ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="surname" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Apellidos</label>
                <div className="col-md-6">
                  <input id="surname" type="text" className={`form-control ${errors?.surname ? 'is-invalid' : ''}`} name="surname" {...surname} />
                  <span className="help-block red">{errors?.surname ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="email" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Correo electrónico</label>
                <div className="col-md-6">
                  <input id="email" type="text" className={`form-control ${errors?.email ? 'is-invalid' : ''}`} name="surname" {...email} />
                  <span className="help-block red">{errors?.email ? 'Required and must be an email' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="phone" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Teléfono</label>
                <div className="col-md-6">
                  <input id="phone" type="text" className={`form-control ${errors?.phone ? 'is-invalid' : ''}`} name="phone" {...phone} />
                  <span className="help-block red">{errors?.phone ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="type_id" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tipo de documento</label>
                <div className="col-md-6">
                  <select name="type_id" className={`form-control ${errors?.type_id ? 'is-invalid' : ''}`} {...type_id}>
                    <option value="">Seleccione</option>
                    <option value="Passport">Pasaporte</option>
                    <option value="ID Card">Tarjeta de identificación</option>
                    <option value="Cedula de ciudadania">Cédula de ciudadania</option>
                    <option value="Cedula de extranjeria">Cédula de extranjeria</option>
                  </select>
                  <span className="help-block red">{errors?.type_id ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="number" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Documento No.</label>
                <div className="col-md-6">
                  <input id="number" type="text" className={`form-control ${errors?.number ? 'is-invalid' : ''}`} name="number" {...number} />
                  <span className="help-block red">{errors?.number ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="blood_group" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tipo de sangre</label>
                <div className="col-md-6">
                  <select name="blood_group" className={`form-control ${errors?.blood_group ? 'is-invalid' : ''}`} {...blood_group} >
                    <option value="">Seleccione</option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="dont know">No lo sé</option>
                  </select>
                  <span className="help-block red">{errors?.blood_group ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="eps" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Proveedor de seguro médico / EPS</label>
                <div className="col-md-6">
                  <input id="eps" type="text" className={`form-control ${errors?.eps ? 'is-invalid' : ''}`} name="eps" {...eps} />
                  <span className="help-block red">{errors?.eps ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="nacionality" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Nacionalidad</label>
                <div className="col-md-6">
                  <input id="nacionality" type="text" className={`form-control ${errors?.nacionality ? 'is-invalid' : ''}`} name="nacionality" {...nacionality} />
                  <span className="help-block red">{errors?.nacionality ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="sex" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Sexo</label>
                <div className="col-md-6">
                  <select name="sex" className={`form-control ${errors?.sex ? 'is-invalid' : ''}`} {...sex} >
                    <option value="">Seleccione</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                  <span className="help-block red">{errors?.sex ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="birthday" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Fecha de nacimiento</label>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-3 mb-3 mb-md-0">
                      <input id="birthday" type="text" className={`form-control ${errors?.birthday_day ? 'is-invalid' : ''}`} name="birthday_day" placeholder="Día" {...birthday_day} />
                    </div>
                    <div className="col-md-5 mb-3 mb-md-0">
                      <select name="birthday_month" className={`form-control ${errors?.birthday_month ? 'is-invalid' : ''}`} {...birthday_month} >
                        <option value="">Seleccione</option>
                        <option value="01">Enero</option>
                        <option value="02">Febrero</option>
                        <option value="03">Marzo</option>
                        <option value="04">Abril</option>
                        <option value="05">Mayo</option>
                        <option value="06">Junio</option>
                        <option value="07">Julio</option>
                        <option value="08">Agosto</option>
                        <option value="09">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3 mb-md-0">
                      <input id="birthday" type="text" className={`form-control ${errors?.birthday_year ? 'is-invalid' : ''}`} name="birthday_year" value="" placeholder="Año" {...birthday_year}/>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="address" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Dirección</label>
                <div className="col-md-6">
                  <input id="address" type="text" className={`form-control ${errors?.address ? 'is-invalid' : ''}`} name="address" {...address} />
                  <span className="help-block red">{errors?.address ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="city" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Ciudad</label>
                <div className="col-md-6">
                  <input id="city" type="text" className={`form-control ${errors?.city ? 'is-invalid' : ''}`} name="city" {...city} />
                  <span className="help-block red">{errors?.city ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="country" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> País</label>
                <div className="col-md-6">
                  <input id="country" type="text" className={`form-control ${errors?.country ? 'is-invalid' : ''}`} name="country" {...country} />
                  <span className="help-block red">{errors?.country ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="emergency_contact_name" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Acudiente en caso de emergencia</label>
                <div className="col-md-6">
                  <input id="emergency_contact_name" type="text" className={`form-control ${errors?.emergency_contact_name ? 'is-invalid' : ''}`} name="emergency_contact_name" {...emergency_contact_name} />
                  <span className="help-block red">{errors?.emergency_contact_name ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="emergency_contact_number" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Teléfono acudiente con código de área</label>
                <div className="col-md-6">
                  <input id="emergency_contact_number" type="text" className={`form-control ${errors?.emergency_contact_number ? 'is-invalid' : ''}`} name="emergency_contact_number" {...emergency_contact_number} />
                  <span className="help-block red">{errors?.emergency_contact_number ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="jersey_size" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Talla de Jersey (Específico de género)</label>
                <div className="col-md-2 mb-3 mb-md-0">
                  <select name="jersey_size" className={`form-control ${errors?.jersey_size ? 'is-invalid' : ''}`} {...jersey_size} >
                    <option value="">Seleccione</option>
                    <option value="XS">XS</option>
                    <option value="S">S</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                    <option value="XXL">XXL</option>
                  </select>
                  <span className="help-block red">{errors?.jersey_size ? 'Requerido' : ''}</span>
                </div>
                <div className="col-md-4 text-right">
                  <button type="button" className={`btn btn-ll --${props.package}`} onClick={() => handleOpenModal()}>Guía de Tallas Jersey Kafitt</button>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="t-shirt_size" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Talla de camiseta (Específico de género)</label>
                <div className="col-md-6">
                  <select name="t-shirt_size" className={`form-control ${errors?.t_shirt_size ? 'is-invalid' : ''}`} {...t_shirt_size} >
                    <option value="">Seleccione</option>
                    <option value="XS">XS</option>
                    <option value="S">S</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                    <option value="XXL">XXL</option>
                  </select>
                  <span className="help-block red">{errors?.t_shirt_size ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="instagram" className="col-md-5 col-form-label text-md-right">Usuario Instagram</label>
                <div className="col-md-6">
                  <input id="instagram" type="text" className={`form-control ${errors?.instagram ? 'is-invalid' : ''}`} name="instagram" {...instagram} />
                  <span className="help-block red">{errors?.instagram ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="know" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> ¿Cómo supiste sobre La Leyenda?</label>
                <div className="col-md-6">
                  <select name="know" className={`form-control ${errors?.know ? 'is-invalid' : ''}`} {...know} >
                    <option value="">Seleccione</option>
                    <option value="Word of mouth">Word of mouth</option>
                    <option value="Social networks">Social networks</option>
                    <option value="Article in press">Article in press</option>
                    <option value="Printed publicity">Printed publicity</option>
                    <option value="Other">Other</option>
                  </select>
                  <span className="help-block red">{errors?.know ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="medical_conditions" className="col-md-5 col-form-label text-md-right">¿Tiene alguna condición médica, alergias o requerimientos dietéticos especiales que debemos tener en cuenta?</label>
                <div className="col-md-6">
                  <textarea name="medical_conditions" id="medical_conditions" cols="30" rows="5" className="form-control" {...medical_conditions}></textarea>
                </div>
              </div>

              <div className="form-group row">
                <label for="tipo_bicicleta" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tipo de bicicleta</label>
                <div className="col-md-6">
                    <select name="tipo_bicicleta" className={`form-control ${errors?.type_of_bike ? 'is-invalid' : ''}`} {...type_of_bike}>
                      <option value="">Seleccione</option>
                      <option value="Hardtail">Hardtail</option>
                      <option value="Full suspension">Full suspension</option>
                    </select>
                    <span className="help-block red">{errors?.type_of_bike ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="marca_bicicleta" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Marca de bicicleta</label>
                <div className="col-md-6">
                    <input id="marca_bicicleta" type="text" className={`form-control ${errors?.make_of_bike ? 'is-invalid' : ''}`} name="marca_bicicleta" {...make_of_bike} />
                    <span className="help-block red">{errors?.make_of_bike ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="tipo_transmision" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tipo de transmisión</label>
                <div className="col-md-6">
                    <select name="tipo_transmision" className={`form-control ${errors?.chainset ? 'is-invalid' : ''}`} {...chainset}>
                      <option value="">Seleccione</option>
                      <option value="Monoplato">Single ring</option>
                      <option value="Biplato">Double ring</option>
                      <option value="Triplato">Triple ring</option>
                    </select>
                    <span className="help-block red">{errors?.chainset ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="tamano_rin" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tamaño de rin </label>
                <div className="col-md-6">
                    <select name="tamano_rin" className={`form-control ${errors?.wheel_size ? 'is-invalid' : ''}`} {...wheel_size}>
                      <option value="">Seleccione</option>
                      <option value="29">29</option>
                      <option value="27.5">27.5</option>
                      <option value="26">26</option>
                    </select>
                    <span className="help-block red">{errors?.wheel_size ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="numero_velocidades" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Número de velocidades</label>
                <div className="col-md-6">
                    <select name="numero_velocidades" className={`form-control ${errors?.number_of_speeds ? 'is-invalid' : ''}`} {...number_of_speeds}>
                      <option value="">Seleccione</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    <span className="help-block red">{errors?.number_of_speeds ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="marca_frenos" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Marca de frenos </label>
                <div className="col-md-6">
                    <select name="marca_frenos" className={`form-control ${errors?.make_of_brakes ? 'is-invalid' : ''}`} {...make_of_brakes}>
                      <option value="">Seleccione</option>
                      <option value="Shimano">Shimano</option>
                      <option value="SRAM">SRAM</option>
                      <option value="Magura">Magura</option>
                      <option value="Hope">Hope</option>
                      <option value="Tektro">Tektro</option>
                      <option value="Otra">Other</option>
                    </select>
                    <span className="help-block red">{errors?.make_of_brakes ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="transmision" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Transmisión</label>
                <div className="col-md-6">
                    <select name="transmision" className={`form-control ${errors?.drivetrain ? 'is-invalid' : ''}`} {...drivetrain}>
                      <option value="">Seleccione</option>
                      <option value="SRAM">SRAM</option>
                      <option value="Shimano">Shimano</option>
                      <option value="Shimano">Shimano Di2</option>
                    </select>
                    <span className="help-block red">{errors?.drivetrain ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row">
                <label for="payment" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Método de pago </label>
                <div className="col-md-6">
                    <select name="payment" className={`form-control ${errors?.payment ? 'is-invalid' : ''}`} {...payment}>
                      <option value="">Seleccione</option>
                      <option value="Bank transfer">Transferencia bancaria</option>
                      <option value="Credit/debit card">Tarjeta Credito/Debito (6% de cargo adicional a la transacción)</option>
                    </select>
                    <span className="help-block red">{errors?.payment ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="col-12 text-justify">
                {ReactHtmlParser(props.booknow)}
              </div>
              <div className="col-12">
                <div>
                  <div className="radio">
                    <label>
                      <span className="red">*</span>
                      <input type="checkbox" name="liability_disclaimer" id="liability_disclaimer" {...liability_disclaimer} />
                      Acepto <a className={`black-link --${props.package}`} href="https://la-leyenda.com/adventures/documents/liability_disclaimer.pdf" target="blank"> La Leyenda Adventures Formato de Exoneración de Responsibilidad e Indemnización</a>
                    </label>
                    <span className="help-block red ml-1">{errors?.liability_disclaimer ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div>
                  <div className="radio">
                    <label>
                      <span className="red">*</span>
                      <input type="checkbox" name="terms_and_conditions" id="terms_and_conditions" {...terms_and_conditions} />
                      Acepto <a className={`black-link --${props.package}`} href="https://la-leyenda.com/adventures/documents/terms_and_conditions.pdf" target="blank">La Leyenda Adventures Términos y Condiciones</a>
                    </label>
                    <span className="help-block red ml-1">{errors?.terms_and_conditions ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div>
                  <div className="radio">
                    <label>
                      <span className="red">*</span>
                      <input type="checkbox" name="medical" id="medical" {...medical} />
                      Declaro tener un Seguro Médico apropiado
                    </label>
                    <span className="help-block red ml-1">{errors?.medical ? 'Requerido' : ''}</span>
                  </div>
                </div>
              </div>

              <div className="col-12 text-justify">
                {ReactHtmlParser(props.signature)}
              </div>

              <div className="form-group row">
                <label htmlFor="signature" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Firma electrónica</label>
                <div className="col-md-6">
                  <input id="signature" type="text" className={`form-control ${errors?.signature ? 'is-invalid' : ''}`} name="signature" {...signature} />
                  <span className="help-block red">{errors?.signature ? 'Requerido' : ''}</span>
                </div>
              </div>

              <div className="form-group row justify-content-end">
                <div className="col-md-3">
                  <button type="submit" className={`btn btn-ll --${props.package}`}>CONTINUAR</button>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>

      <div className="modal fade show" id="tallasModal" tabindex="-1" role="dialog" aria-labelledby="tallasModalLabel" aria-modal="true" style={{display: modal}}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="tallasModalLabel">Guía de tallas Kafitt</h5>
              <button type="button" className="close" onClick={() => handleCloseModal()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <img className="img-fluid" src="https://la-leyenda.com/series-2020/img/tallas.jpg" alt="" />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => handleCloseModal()}>Cerrar</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
};

export default FormBookNow;
